import React, { useState, useEffect } from "react";
import Select from "react-select"; // Import react-select
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import {
  fetchAllowedMenus,
  fetchUserGroupData,
  fetchUserData,
  updateUser,
  fetchAllUserType,
  fetchProjectData,
  fetchAllAssigedProject,
  UpdateUserTargets,
  fetchMeadiaSourceData,
  fetchAllAssignmentTypes,
  fetchAllCampaignServices,
  fetchAllSubMediaSource,
} from "../Services/APIService";
import {
  User,
  UpdateUser,
  MenuItem,
  userTypeItem,
} from "../Services/APIService";
import { Toaster, toast } from "react-hot-toast";
import { MultiValue, ActionMeta } from "react-select";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";

interface UserGroup {
  groupId: number;
  groupName: string;
}

// Define interface for the Select options
interface SelectOption {
  value: number;
  label: string;
  userData: User;
}

// Define interface for project select options
interface ProjectSelectOption {
  value: number;
  label: string;
}

interface MediaSourceSelectOption {
  value: number;
  label: string;
}

// Define interface for validation errors
interface ValidationErrors {
  userName?: string;
  mobile?: string;
  email?: string;
  alternativePhone?: string;
  password?: string;
  groupId?: string;
  userTypeId?: string;
  assignmentTypeId?: string;
  listOfAssignments?: string;
}

// Define interface for Project data
interface Project {
  projectID: number;
  projectName: string;
  description?: string;
  locationID?: number;
}

export interface MeadiaSource {
  sourceId: number;
  sourceName: string;
  isActive: boolean;
  createdBy: number;
  createdOn: string;
}

// Define interface for User Assignment data
interface UserAssignment {
  assignmentId: number;
  assignmentObjectId: number;
  assignmentName: string;
  assignmentTypeId: number;
  assignmentTypeName: string;
  isActive: boolean;
}

// Define interface for User Assignment request
interface UserAssignmentRequest {
  userId: number;
  assignmentTypeId: number;
  listOfAssignments: {
    assignmentObjectId: number;
  }[];
  isAssigned: boolean;
  tenantId: number;
  createdBy: number;
}

interface AssignmentProjectRequest {
  userId: number;
  assignmentTypeId: number;
  listOfAssignments: {
    userId: number;
  }[];
  isAssigned: boolean;
  tenantId: number;
  createdBy: number;
}

// NEW CODE: Dynamic Assignment Types interfaces
// Generic interface for any assignment option
interface GenericAssignmentOption {
  value: number;
  label: string;
}

interface GenericAssignmentItem {
  id: number;
  name: string;
}

// Dynamic assignment state for any type
interface DynamicAssignmentState {
  options: GenericAssignmentOption[];
  selected: GenericAssignmentOption[];
  previousSelected: number[];
  isDropdownChanged: boolean;
  isLoading: boolean;
  typeName: string;
}
// END NEW CODE

const EditUser: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // State for user data
  const [userData, setUserData] = useState<User | null>(null);
  // Additional state for password since it may not be part of the user data object
  const [password, setPassword] = useState("");
  // State for validation errors
  const [errors, setErrors] = useState<ValidationErrors>({});

  // Sidebar states
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [allowedMenus, setAllowedMenus] = useState<MenuItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const [userGroups, setUserGroups] = useState<UserGroup[]>([]);
  const [users, setUsers] = useState<User[]>([]); // Store fetched users
  const [userOptions, setUserOptions] = useState<SelectOption[]>([]); // Store formatted options
  const [selectedManager, setSelectedManager] = useState<SelectOption | null>(
    null
  );

  const [userTypes, setUserTypes] = useState<userTypeItem[]>([]);
  const [isLoadingUserTypes, setIsLoadingUserTypes] = useState(true);
  const [activeTab, setActiveTab] = useState("tab1");

  const [isSubmittingAssignment, setIsSubmittingAssignment] = useState(false);

  // NEW CODE: Dynamic Assignment Types states and constants
  // State to store the dynamic assignment type IDs
  const [dynamicAssignmentTypeIds, setDynamicAssignmentTypeIds] = useState<
    number[]
  >([]); // TODO: I have done

  // State for dynamic assignment types - initialized empty and filled by API
  const [dynamicAssignmentStates, setDynamicAssignmentStates] = useState<
    Record<number, DynamicAssignmentState>
  >({}); // TODO: I have done

  // Initialize assignment types dynamically
  useEffect(() => {
    const initializeAssignmentTypes = async () => {
      try {
        // Fetch all assignment types
        const allAssignmentTypes = await fetchAllAssignmentTypes();

        const filteredTypes = allAssignmentTypes;

        // Extract type IDs for later use
        const typeIds = filteredTypes.map((type) => type.typeId);
        setDynamicAssignmentTypeIds(typeIds);

        // Initialize state for each type
        const initialStates: Record<number, DynamicAssignmentState> = {};

        for (const type of filteredTypes) {
          initialStates[type.typeId] = {
            options: [],
            selected: [],
            previousSelected: [],
            isDropdownChanged: false,
            isLoading: true,
            typeName: type.typeName,
          };
        }

        setDynamicAssignmentStates(initialStates);
      } catch (error) {
        console.error("Error initializing assignment types:", error);
      }
    };

    initializeAssignmentTypes();
  }, []); // TODO: I have done

  // Load data for each assignment type
  useEffect(() => {
    const loadAssignmentData = async () => {
      if (dynamicAssignmentTypeIds.length === 0) return;

      try {
        // Load data for each assignment type
        for (const typeId of dynamicAssignmentTypeIds) {
          // Fetch options for this type
          const items = await fetchAssignmentDataByType(typeId);

          // Format as options
          const options = items.map((item) => ({
            value: item.id,
            label: item.name,
          }));

          // Update state for this type
          setDynamicAssignmentStates((prevStates) => ({
            ...prevStates,
            [typeId]: {
              ...prevStates[typeId],
              options,
              isLoading: false,
            },
          }));
        }
      } catch (error) {
        console.error("Error loading assignment data:", error);
      }
    };

    loadAssignmentData();
  }, [dynamicAssignmentTypeIds]);

  // Load user's assigned items when userData changes
  useEffect(() => {
    const loadUserAssignments = async () => {
      if (!userData?.userId || dynamicAssignmentTypeIds.length === 0) return;

      try {
        for (const typeId of dynamicAssignmentTypeIds) {
          const assignedItems = await fetchAllAssigedProject(
            userData.userId,
            typeId
          );

          if (assignedItems && assignedItems.length > 0) {
            // Format assigned items as select options
            const selected = assignedItems.map((item) => ({
              value: item.assignmentObjectId,
              label: item.assignmentName,
            }));

            // Store previous selected values for comparison during updates
            const previousSelected = selected.map((item) => item.value);

            // Update state for this assignment type
            setDynamicAssignmentStates((prevStates) => ({
              ...prevStates,
              [typeId]: {
                ...prevStates[typeId],
                selected,
                previousSelected,
                isDropdownChanged: false,
              },
            }));
          }
        }
      } catch (error) {
        console.error("Error loading user assignments:", error);
      }
    };

    loadUserAssignments();
  }, [userData?.userId, dynamicAssignmentTypeIds]);
  // END NEW CODE

  // NEW CODE: Dynamic function to fetch assignment data based on type
  const fetchAssignmentDataByType = async (
    typeId: number
  ): Promise<GenericAssignmentItem[]> => {
    try {
      let result: GenericAssignmentItem[] = [];

      switch (typeId) {
        case 1: {
          const campaignServices = await fetchAllCampaignServices();
          result = campaignServices.map((service) => ({
            id: service.campaignId,
            name: service.campaignName,
          }));
          break;
        }
        case 2: {
          const projectservice = await fetchProjectData();
          result = projectservice.map((proj) => ({
            id: proj.projectID,
            name: proj.projectName,
          }));
          break;
        }
        case 3: {
          const mediasourceservice = await fetchMeadiaSourceData();
          result = mediasourceservice.map((source) => ({
            id: source.sourceId,
            name: source.sourceName,
          }));
          break;
        }
        case 4: {
          const subMediaSources = await fetchAllSubMediaSource();
          result = subMediaSources.map((source) => ({
            id: source.id,
            name: source.name,
            isActive: source.isActive,
          }));
          break;
        }
        default:
          result = [];
          break;
      }

      return result;
    } catch (error) {
      console.error(
        `Error fetching data for assignment type ${typeId}:`,
        error
      );
      return [];
    }
  };
  // END NEW CODE

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  // CSS for required field indicator
  const requiredField = <span className="text-danger ms-1">*</span>;

  // Toggle sidebar
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  // Validation functions
  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile: string): boolean => {
    const mobileRegex = /^\d+$/;
    return mobileRegex.test(mobile);
  };

  // Fetch menus, user groups, and users
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setIsLoadingUserTypes(true);
      try {
        const [menus, groups, usersData, types] = await Promise.all([
          fetchAllowedMenus(),
          fetchUserGroupData(),
          fetchUserData(),
          fetchAllUserType(),
        ]);

        setAllowedMenus(menus);
        setUserGroups(groups);
        setUsers(usersData);

        if (types && types.length > 0) {
          setUserTypes(types);
        }

        // Format users as select options with full user data attached
        const options = usersData.map((user) => ({
          value: user.userId,
          label: `${user.userName} (${user.email})`,
          userData: user, // Store the full user object for reference
        }));
        setUserOptions(options);
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load required data");
      } finally {
        setIsLoading(false);
        setIsLoadingUserTypes(false);
      }
    };

    fetchData();
  }, []);

  // Load user data from navigation state and set selected manager
  useEffect(() => {
    const loadUserData = async () => {
      const user = location.state?.userData;
      if (user) {
        // Initialize isFallbackUser if not present
        if (user.isFallbackUser === undefined) {
          user.isFallbackUser = false;
        }
        setUserData(user);

        // If user has a reportTo value, find the corresponding user in options
        if (user.reportTo && users.length > 0) {
          const managerUser = users.find((u) => u.userId === user.reportTo);
          if (managerUser) {
            setSelectedManager({
              value: managerUser.userId,
              label: `${managerUser.userName} (${managerUser.email})`,
              userData: managerUser,
            });
          }
        }
      } else {
        // Redirect if no user data
        navigate("/users");
      }
    };

    loadUserData();
  }, [location, navigate, users]);

  // Handle form input changes with validation
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;

    // Prevent leading spaces for all inputs
    if (value.startsWith(" ")) {
      return;
    }

    if (name === "password") {
      setPassword(value);
    } else if (userData) {
      setUserData({
        ...userData,
        [name]: value,
      });
    }

    // Clear errors when user types
    if (errors[name as keyof ValidationErrors]) {
      setErrors({
        ...errors,
        [name]: undefined,
      });
    }
  };

  // Handle checkbox changes
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (userData) {
      setUserData({
        ...userData,
        [e.target.name]: e.target.checked,
      });
    }
  };

  // NEW CODE: Handle dynamic assignment dropdown changes
  const handleDynamicAssignmentChange = (
    typeId: number,
    newValue: MultiValue<GenericAssignmentOption>,
    actionMeta: ActionMeta<GenericAssignmentOption>
  ) => {
    // Convert MultiValue to array of DynamicAssignmentSelectOption
    const selectedOptions = Array.isArray(newValue) ? newValue : [newValue];

    setDynamicAssignmentStates((prevStates) => ({
      ...prevStates,
      [typeId]: {
        ...prevStates[typeId],
        selected: selectedOptions,
        isDropdownChanged: true,
      },
    }));
  };
  // END NEW CODE

  // Handle selection for reportTo dropdown
  const handleManagerChange = (selectedOption: SelectOption | null) => {
    setSelectedManager(selectedOption);
    if (userData && selectedOption) {
      setUserData({
        ...userData,
        reportTo: selectedOption.userData.userId,
      });
    } else if (userData) {
      setUserData({
        ...userData,
        reportTo: 0, // or null, depending on your API requirements
      });
    }
  };

  // Handle group dropdown changes
  const handleGroupChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (userData) {
      setUserData({
        ...userData,
        groupId: parseInt(e.target.value),
      });
    }

    // Clear errors when user selects a group
    if (errors.groupId) {
      setErrors({
        ...errors,
        groupId: undefined,
      });
    }
  };

  const handleUserTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (userData) {
      setUserData({
        ...userData,
        userTypeId: parseInt(e.target.value),
      });
    }

    // Clear errors when user selects a type
    if (errors.userTypeId) {
      setErrors({
        ...errors,
        userTypeId: undefined,
      });
    }
  };

  // Validate form before submission
  const validateForm = (): boolean => {
    const newErrors: ValidationErrors = {};
    let isValid = true;

    // Required field validations
    if (!userData?.userName?.trim()) {
      newErrors.userName = "User name is required";
      isValid = false;
    }

    if (!userData?.mobile?.trim()) {
      newErrors.mobile = "Mobile number is required";
      isValid = false;
    } else if (!validateMobile(userData.mobile)) {
      newErrors.mobile = "Mobile number should contain only digits";
      isValid = false;
    }

    if (!userData?.email?.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!validateEmail(userData.email)) {
      newErrors.email = "Invalid email format";
      isValid = false;
    }

    if (
      userData?.alternativePhone &&
      !validateMobile(userData.alternativePhone)
    ) {
      newErrors.alternativePhone =
        "Alternative phone should contain only digits";
      isValid = false;
    }

    if (!userData?.groupId) {
      newErrors.groupId = "Group selection is required";
      isValid = false;
    }

    // User Type validation
    if (!userData?.userTypeId) {
      newErrors.userTypeId = "User Type selection is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Handle form submission with validation
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate form before submission
    if (!validateForm()) {
      //toast.error("Please fix the errors in the form");
      return;
    }

    const userId = localStorage.getItem("UserId");

    if (!userData) {
      console.error("User data is null");
      return;
    }

    // Create object with all user data
    const fullData = {
      ...userData,
      passwordHash: password || "Test@123",
      modifiedBy: parseInt(userId || "0"),
    };

    // Remove tenantId from the data
    const { tenantId, ...dataWithoutTenantId } = fullData;
    const success = await updateUser(dataWithoutTenantId as UpdateUser);
    if (success) {
      toast.success("User Updated Successfully!");
      setTimeout(() => {
        navigate("/userview");
      }, 1000);
    } else {
      // Handle error - maybe show a notification to the user
      toast.error("Failed to update user");
    }
  };

  // Handle assignment submission
  const handleAssignmentSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Prepare assignment data
    const userId = userData?.userId || 0;
    const tenantId = localStorage.getItem("tenantId");
    const createdBy = localStorage.getItem("UserId");

    try {
      setIsSubmittingAssignment(true);

      // NEW CODE: Process dynamic assignment types (1 and 4)
      for (const typeId of dynamicAssignmentTypeIds) {
        const state = dynamicAssignmentStates[typeId];

        if (!state.isDropdownChanged) {
          continue; // Skip if no changes for this type
        }

        // Get currently selected items
        const currentSelected = state.selected.map((item) => item.value);

        // Find items that were previously selected but are no longer selected (removed)
        const unselectedItems = state.previousSelected.filter(
          (itemId) => !currentSelected.includes(itemId)
        );

        // Process unselected items (remove assignments)
        if (unselectedItems.length > 0) {
          const assignmentRequest: UserAssignmentRequest = {
            userId,
            assignmentTypeId: typeId,
            listOfAssignments: unselectedItems.map((itemId) => ({
              assignmentObjectId: itemId,
            })),
            isAssigned: false,
            tenantId: tenantId ? parseInt(tenantId) : 0,
            createdBy: createdBy ? parseInt(createdBy) : 0,
          };

          await UpdateUserTargets(assignmentRequest);
        }

        // Process selected items (add assignments)
        if (currentSelected.length > 0) {
          const assignmentRequest: UserAssignmentRequest = {
            userId,
            assignmentTypeId: typeId,
            listOfAssignments: currentSelected.map((itemId) => ({
              assignmentObjectId: itemId,
            })),
            isAssigned: true,
            tenantId: tenantId ? parseInt(tenantId) : 0,
            createdBy: createdBy ? parseInt(createdBy) : 0,
          };

          await UpdateUserTargets(assignmentRequest);
        }

        // Update previous selected list for future comparisons
        setDynamicAssignmentStates((prevStates) => ({
          ...prevStates,
          [typeId]: {
            ...prevStates[typeId],
            previousSelected: currentSelected,
            isDropdownChanged: false,
          },
        }));
      }
      // END NEW CODE

      toast.success("Assigned successfully");
    } catch (error) {
      console.error("Error assigning projects:", error);
      toast.error("An error occurred while assigning projects");
    } finally {
      setIsSubmittingAssignment(false);
    }
  };

  if (!userData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="wrapper">
      <div>
        <Toaster
          position="top-center"
          reverseOrder={false}
          containerStyle={{
            zIndex: 10000,
          }}
        />
      </div>
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />
        <div className="main-content-div">
          <div className="main-header-div"></div>
          <main className="content mainContent">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-12 col-lg-12">
                  <div className="card">
                    <ul
                      className="nav nav-tabs cardHeaderHegiht tabHeaderPadding"
                      id="myTab"
                      role="tablist"
                      style={{ borderBottom: "1px solid #84556b" }}
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link card-title tab-btn cardHeaderHegiht ${
                            activeTab === "tab1" ? "active" : ""
                          }`}
                          id="tab1-tab"
                          onClick={() => handleTabClick("tab1")}
                          type="button"
                          role="tab"
                          aria-controls="tab1-tab-pane"
                          aria-selected={activeTab === "tab1"}
                        >
                          User Details
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link card-title tab-btn cardHeaderHegiht ${
                            activeTab === "tab3" ? "active" : ""
                          }`}
                          id="tab3-tab"
                          onClick={() => handleTabClick("tab3")}
                          type="button"
                          role="tab"
                          aria-controls="tab3-tab-pane"
                          aria-selected={activeTab === "tab3"}
                        >
                          Assigned Information
                        </button>
                      </li>
                    </ul>

                    <div className="tab-content card-body" id="myTabContent">
                      {/* tab1 Tab */}
                      <div
                        className={`tab-pane fade ${
                          activeTab === "tab1" ? "show active" : ""
                        }`}
                        id="tab1-tab-pane"
                        role="tabpanel"
                        aria-labelledby="tab1-tab"
                        tabIndex={0}
                      >
                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label className="form-label">
                                User Name{requiredField}
                              </label>
                              <input
                                type="text"
                                className={`form-control ${
                                  errors.userName ? "is-invalid" : ""
                                }`}
                                name="userName"
                                value={userData.userName}
                                onChange={handleInputChange}
                                required
                              />
                              {errors.userName && (
                                <div className="invalid-feedback text-danger">
                                  {errors.userName}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label">
                                Email{requiredField}
                              </label>
                              <input
                                type="email"
                                className={`form-control ${
                                  errors.email ? "is-invalid" : ""
                                }`}
                                name="email"
                                value={userData.email}
                                onChange={handleInputChange}
                                required
                              />
                              {errors.email && (
                                <div className="invalid-feedback text-danger">
                                  {errors.email}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label">
                                Mobile{requiredField}
                              </label>
                              <input
                                type="tel"
                                className={`form-control ${
                                  errors.mobile ? "is-invalid" : ""
                                }`}
                                name="mobile"
                                value={userData.mobile}
                                onChange={handleInputChange}
                                required
                              />
                              {errors.mobile && (
                                <div className="invalid-feedback text-danger">
                                  {errors.mobile}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label">
                                Alternative Phone
                              </label>
                              <input
                                type="tel"
                                className={`form-control ${
                                  errors.alternativePhone ? "is-invalid" : ""
                                }`}
                                name="alternativePhone"
                                value={userData.alternativePhone}
                                onChange={handleInputChange}
                              />
                              {errors.alternativePhone && (
                                <div className="invalid-feedback text-danger">
                                  {errors.alternativePhone}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label">Reports To</label>
                              <Select
                                options={userOptions}
                                value={selectedManager}
                                onChange={handleManagerChange}
                                className="basic-single-select"
                                classNamePrefix="select"
                                placeholder="Select manager"
                                isLoading={isLoading}
                                isClearable
                              />
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label">
                                Group{requiredField}
                              </label>
                              <select
                                name="groupId"
                                value={userData.groupId}
                                onChange={handleGroupChange}
                                className={`form-select ${
                                  errors.groupId ? "is-invalid" : ""
                                }`}
                                required
                              >
                                <option value="">Select Group</option>
                                {userGroups.map((group) => (
                                  <option
                                    key={group.groupId}
                                    value={group.groupId}
                                  >
                                    {group.groupName}
                                  </option>
                                ))}
                              </select>
                              {errors.groupId && (
                                <div className="invalid-feedback text-danger">
                                  {errors.groupId}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label">
                                User Type{requiredField}
                              </label>
                              <select
                                name="userTypeId"
                                value={userData.userTypeId}
                                onChange={handleUserTypeChange}
                                className={`form-select ${
                                  errors.userTypeId ? "is-invalid" : ""
                                }`}
                                required
                                disabled={
                                  userTypes.length === 0 || isLoadingUserTypes
                                }
                              >
                                {isLoadingUserTypes ? (
                                  <option value="">
                                    Loading user types...
                                  </option>
                                ) : userTypes.length > 0 ? (
                                  userTypes.map((type) => (
                                    <option
                                      key={type.typeId}
                                      value={type.typeId}
                                    >
                                      {type.typeName}
                                    </option>
                                  ))
                                ) : (
                                  <option value="">
                                    No user types available
                                  </option>
                                )}
                              </select>
                              {errors.userTypeId && (
                                <div className="invalid-feedback text-danger">
                                  {errors.userTypeId}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-3 mt-4">
                              <div className="row">
                                <div className="col-4">
                                  <div className="form-check mt-2">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="isFallbackUserCheckbox"
                                      name="isFallbackUser"
                                      checked={userData.isFallbackUser}
                                      onChange={handleCheckboxChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="isFallbackUserCheckbox"
                                    >
                                      Is Fallback User
                                    </label>
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="form-check mt-2">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="isActiveCheckbox"
                                      name="isActive"
                                      checked={userData.isActive}
                                      onChange={handleCheckboxChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="isActiveCheckbox"
                                    >
                                      Is Active
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      {/* Assigned Projects tab */}
                      <div
                        className={`tab-pane fade ${
                          activeTab === "tab3" ? "show active" : ""
                        }`}
                        id="tab3-tab-pane"
                        role="tabpanel"
                        aria-labelledby="tab3-tab"
                        tabIndex={0}
                      >
                        <form onSubmit={handleAssignmentSubmit}>
                          <div className="row">
                            {/* NEW CODE: Dynamic assignment dropdowns */}
                            {dynamicAssignmentTypeIds.map((typeId) => (
                              <div
                                className="col-12 col-lg-12 mb-3"
                                key={typeId}
                              >
                                <label className="form-label">
                                  Assigned{" "}
                                  {dynamicAssignmentStates[typeId].typeName}
                                </label>
                                <Select
                                  isMulti
                                  options={
                                    dynamicAssignmentStates[typeId].options ||
                                    []
                                  }
                                  value={
                                    dynamicAssignmentStates[typeId].selected ||
                                    []
                                  }
                                  onChange={(
                                    newValue: MultiValue<GenericAssignmentOption>,
                                    actionMeta: ActionMeta<GenericAssignmentOption>
                                  ) =>
                                    handleDynamicAssignmentChange(
                                      typeId,
                                      newValue,
                                      actionMeta
                                    )
                                  }
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  placeholder={`Select ${dynamicAssignmentStates[typeId]?.typeName} to assign`}
                                  isLoading={
                                    dynamicAssignmentStates[typeId]?.isLoading
                                  }
                                />
                                <div className="form-text">
                                  Select multiple{" "}
                                  {dynamicAssignmentStates[typeId]?.typeName} to
                                  assign to this user
                                </div>
                              </div>
                            ))}
                            {/* END NEW CODE */}
                          </div>
                        </form>
                      </div>

                      {/* Action buttons at bottom */}
                      <div>
                        {activeTab !== "tab3" ? (
                          <>
                            <button
                              type="submit"
                              className="btn btn-primary me-2"
                              onClick={handleSubmit}
                            >
                              Update User
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => navigate("/userview")}
                            >
                              <i className="bi bi-arrow-return-left"></i> Back
                              To List
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary me-2"
                              onClick={handleAssignmentSubmit}
                              disabled={isSubmittingAssignment}
                            >
                              {isSubmittingAssignment
                                ? "Saving..."
                                : "Save Assigned"}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => navigate("/userview")}
                            >
                              <i className="bi bi-arrow-return-left"></i> Back
                              To List
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default EditUser;
